import React from "react";
import { useNavigate } from "react-router-dom";
import { createFloorAssign, getAllFloors } from "adminApi/FloorAssignApi/FloorAssign";
import { FloorAssignRules } from "validation/ValidationRules";
import Spinner from "Common/Globle/Spinner";
import useFormChange from "Hooks/useFormChange";
import useFormSubmit from "Hooks/useFormSubmit";
import { validateForm } from "utils/validation";
import fields from "../json/FloorAssignField.json";
import AddFloorAssignForm from "./Components/AddFloorAssignForm";
import useFetchAllData from "Hooks/useFetchAllData";

const AddFloorAssign = () => {
    const navigate = useNavigate();
    const { formdata } = fields;

    // Build initial values from field definitions
    const initialValues = formdata.reduce((acc, field) => ({ ...acc, [field.name]: "" }), {});

    const { values, errors, handleChange, setValues, setErrors } = useFormChange(
        initialValues,
        FloorAssignRules
    );

    const { data: floorOptions, loading: loadingFloor } = useFetchAllData(getAllFloors);

    const { loading: loadingSubmit, handleSubmit } = useFormSubmit(
        async (formValues) => {
            console.log("formValues", formValues);
            await createFloorAssign({ data: formValues })
        },
        (vals) => {
            // Copy before mutating to avoid modifying original state
            const v = { ...vals };
            delete v.button;
            const err = validateForm(v, FloorAssignRules);
            setErrors(err);
            return err;
        },
        () => navigate(-1),
        "Floor Assigned Successfully"
    );

    return (
        <>
            {(loadingSubmit || loadingFloor) && <Spinner isSpinner={true} />}
            <AddFloorAssignForm
                fields={formdata}
                values={values}
                errors={errors}
                handleChange={handleChange}
                handleSubmit={(e) => handleSubmit(e, values)}
                loading={loadingSubmit}
                floorOptions={floorOptions || []}
                setValues={setValues}
            />
        </>
    );
};

export default AddFloorAssign;
